import { FC } from 'react'

import { Button, ButtonSizes, ButtonVariants } from '@inno-ui/button'
import { MultiplyIcon } from '@inno-ui/icons'
import cn from 'classnames'
import { AnimatePresence, motion } from 'motion/react'

import {
  WINDOW_CONTENT_ANIMATION,
  WINDOW_FADE_TRANSITION,
  WINDOW_SPRING_TRANSITION,
  WINDOW_WRAPPER_ANIMATION
} from './UtilityWindowWrapper.constants'
import styles from './UtilityWindowWrapper.module.scss'
import { UtilityWindowWrapperProps } from './UtilityWindowWrapper.types'

export const UtilityWindowWrapper: FC<UtilityWindowWrapperProps> = ({
  isOpen,
  title,
  onClose,
  children,
  className
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          variants={WINDOW_WRAPPER_ANIMATION}
          initial='initial'
          animate='animate'
          exit='exit'
          transition={WINDOW_FADE_TRANSITION}
          className={cn(styles.wrapper, className)}
        >
          <motion.div
            variants={WINDOW_CONTENT_ANIMATION}
            initial='initial'
            animate='animate'
            exit='exit'
            transition={WINDOW_SPRING_TRANSITION}
            className={styles.content}
            onClick={e => e.stopPropagation()}
          >
            <div className={styles.header}>
              <h2 className={styles.title}>{title}</h2>
              <Button
                variant={ButtonVariants.Ghost}
                onClick={onClose}
                icon={MultiplyIcon}
                size={ButtonSizes.L}
              />
            </div>
            <div className={styles.main}>{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
